import { FaLinkedinIn } from 'react-icons/fa'

const LinkedIn = () => {
   return (
      <>
         <a href="https://www.linkedin.com/company/latitud-sur-compania-argentina-de-seguros/" target="_blank" className="linkedin-float pulse" title="Linkedin">
            <FaLinkedinIn/>
         </a>
      </>
   )
}

export default LinkedIn